import axios from "axios";

export default {

    getCourseInfo({ rootState, commit }, payload) {
        let endpoint = this._vm.$url_api + `api/lms/welcome/course`;

        return new Promise((resolve, reject) => {

            let params = {}
            if (payload.id) {
                params.id = payload.id;
            } else if (payload.slug) {
                params.slug = payload.slug;
            }

            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                Authorization : `Bearer ${rootState.token}`
            };

            axios.get(endpoint,
                {
                    headers:headers,
                    params: params
                })
                .then(response => {
                    commit("update_course_data", response.data.data.course);
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error.response.data);
                    reject(error.response.data.data);
                });
        });
    },

    getCourseSections({ rootState, commit }, payload) {
        let endpoint = this._vm.$url_api + `api/lms/welcome/section`;

        return new Promise((resolve, reject) => {

            let params = {}
            if (payload.id) {
                params.id = payload.id;
            } else if (payload.slug) {
                params.slug = payload.slug;
            }

            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                Authorization : `Bearer ${rootState.token}`
            };

            axios.get(endpoint,
                {
                    headers:headers,
                    params: params
                })
                .then(response => {
                    commit("update_course_sections", response.data.data.section);
                    resolve(response.data.data.section);
                })
                .catch(error => {
                    console.log(error.response.data);
                    reject(error.response.data.data);
                });
        });
    },

    getSectionLessons({ rootState, commit }, payload) {
        let endpoint     = this._vm.$url_api + `api/lms/welcome/lesson`;

        return new Promise((resolve, reject) => {

            let params = {}
            if (payload.id) {
                params.id = payload.id;
            } else if (payload.slug) {
                params.slug = payload.slug;
            }

            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                Authorization : `Bearer ${rootState.token}`
            };

            axios.get(endpoint,
                {
                    headers:headers,
                    params: params
                })
                .then(response => {
                    commit("update_section_lessons", response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error.response.data);
                    reject(error.response.data.data);
                });
        });
    },

    updateScormUserInfo({ state, commit, rootState }, payload) {

        let endpoint = this._vm.$url_api + `api/lms/scorm/update_user_info`;
        if (payload?.forced === true) {
            endpoint = this._vm.$url_api + `api/lms/scorm/update_user_info_time`;

            try {
                fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: `Bearer ${rootState.token}`
                    },
                    body: JSON.stringify(payload),
                    keepalive: true,
                });
            } catch (e) {
                console.warn('Erro no save forçado SCORM:', e);
            }

            return Promise.resolve({ forced: true });
        }
        // Avoid two requests at the same time
        if(state.processing){
            return Promise.reject();
        }

        return new Promise((resolve, reject) => {

            commit("update_processing", true);

            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                Authorization : `Bearer ${rootState.token}`
            };

            axios.post(
                endpoint,
                payload, { headers: headers })
                .then(response =>{
                    resolve(response);
                })
                .catch(error => {
                    console.log(error.response.data.errors || error.response.data.data);
                    reject(error.response.data.errors || error.response.data.data);
                })
                .finally(() => {
                    commit("update_processing", false);
                })

        });

    },

    getScormUserInfo({ rootState }, payload) {

        let endpoint = this._vm.$url_api + `api/lms/scorm/get_user_info`;

        return new Promise((resolve, reject) => {

            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                Authorization : `Bearer ${rootState.token}`
            };

            axios.post(
                endpoint,
                payload, { headers: headers })
                .then(response =>{
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error.response.data.errors || error.response.data.data);
                    reject(error.response.data.errors || error.response.data.data);
                });

        });

    }

};